module.exports = __webpack_public_path__ + "static/media/the-ham.20bac072.jpg";